<emergency-empty-state *ngIf="this.sharedConfig.schedulesActive.length <= 0"></emergency-empty-state>

<emergency-with-assistance-benefits *ngIf="schedulesWithAssistanceBenefits.length > 0"></emergency-with-assistance-benefits>

<emergency-without-assistance-benefits
  *ngIf="this.schedulesWithAssistanceBenefits.length <= 0 && this.sharedConfig.schedulesActive.length > 0"
></emergency-without-assistance-benefits>
